import { Injectable } from '@angular/core';
import gql from 'graphql-tag';
import { QueryResult } from '../shared/object/queryResult.model';
import { GraphQLClient } from '../shared/services/graph-qlclient.service';

@Injectable({
  providedIn: 'root',
})
export class ClienteProveedorService {
  constructor(private gqlclient: GraphQLClient) { }

  public TransferenciaVendedor = (inputParams, callback: Function) => {
    this.gqlclient.query(
      {
        query: gql`
          mutation ($entidad: traspaso_clienteInputType, $clientes: [cliente_proveedorInputType]) {
            traspaso_cliente {
              transferenciaVendedor(entidad: $entidad, clientes: $clientes) {
                mensajes {
                  codigo
                  texto
                  tipo
                }
                respuesta {
                  empresa_rut
                  sucursal_codigo
                  vendedor_codigo_origen
                  vendedor_codigo_destino
                  cliente_proveedor_rut
                  direccion_codigo
                  herreda_ipt
                  lunes
                  martes
                  miercoles
                  jueves
                  viernes
                  sabado
                  domingo
                }
              }
            }
          }
        `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { mensajes, respuesta } = response.data.traspaso_cliente.transferenciaVendedor;
        if (!respuesta) {
          // callback({ registros: null, paginaActual: 0, totalPaginas: 0, totalRegistros: 0 })
          callback(new QueryResult(null, 0, 0, 0));
          return;
        }

        const { registros, paginaActual, totalPaginas, totalRegistros } = respuesta;
        callback(new QueryResult(registros, paginaActual, totalPaginas, totalRegistros));
      }
    );
  };

  public obtenerClienteSegunVendedor = (inputParams, callback: Function) => {
    this.gqlclient.query(
      {
        query: gql`
          query ($entidad: vendedor_rubro_clienteInputType, $paginaActual: Int, $cantidadRegistrosPorPagina: Int) {
            cliente_proveedor {
              obtenerClienteSegunVendedor(entidad: $entidad, paginaActual: $paginaActual, cantidadRegistrosPorPagina: $cantidadRegistrosPorPagina) {
                mensajes {
                  codigo
                  contexto
                  texto
                  tipo
                }
                respuesta {
                  paginaActual
                  cantidadRegistrosPorPagina
                  totalPaginas
                  totalRegistros
                  registros {
                    rut
                    nombre
                    razon_social
                    codigo_direccion
                    empresa_rut
                    fecha_registro
                    lista_precio_codigo
                    descuento_maximo
                  }
                }
              }
            }
          }
        `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { mensajes, respuesta } = response.data.cliente_proveedor.obtenerClienteSegunVendedor;
        if (!respuesta) {
          // callback({ registros: null, paginaActual: 0, totalPaginas: 0, totalRegistros: 0 })
          callback(new QueryResult(null, 0, 0, 0));
          return;
        }

        const { registros, paginaActual, totalPaginas, totalRegistros } = respuesta;
        callback(new QueryResult(registros, paginaActual, totalPaginas, totalRegistros));
      }
    );
  };

  public obtenerSegunFiltroSoloClientes = (inputParams, callback: Function) => {
    this.gqlclient.query(
      {
        query: gql`
          query ($nombre: String, $rut: Decimal, $busquedaxEstado: Int, $bloqueado: Boolean, $es_cliente: Boolean, $empresa_rut: Decimal, $paginaActual: Int, $cantidadRegistrosPorPagina: Int) {
            cliente_proveedor {
              obtenerSegunFiltroSoloClientes(
                filtro: { exacto: { nombre: $nombre, rut: $rut, busquedaxEstado: $busquedaxEstado, bloqueado: $bloqueado, es_cliente: $es_cliente, empresa_rut: $empresa_rut } }
                paginaActual: $paginaActual
                cantidadRegistrosPorPagina: $cantidadRegistrosPorPagina
              ) {
                mensajes {
                  codigo
                  contexto
                  texto
                  tipo
                }
                respuesta {
                  paginaActual
                  cantidadRegistrosPorPagina
                  totalPaginas
                  totalRegistros
                  registros {
                    rut
                    nombre
                    razon_social
                    codigo_direccion
                    direccion_completa
                    empresa_rut
                    fecha_registro
                    lista_precio_codigo
                    descuento_maximo
                    giro
                    telefono_principal
                    afecto_reglas_comerciales
                    condicion_pago_codigo
                  }
                }
              }
            }
          }
        `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { mensajes, respuesta } = response.data.cliente_proveedor.obtenerSegunFiltroSoloClientes;
        if (!respuesta) {
          // callback({ registros: null, paginaActual: 0, totalPaginas: 0, totalRegistros: 0 })
          callback(new QueryResult(null, 0, 0, 0));
          return;
        }

        const { registros, paginaActual, totalPaginas, totalRegistros } = respuesta;
        callback(new QueryResult(registros, paginaActual, totalPaginas, totalRegistros));
      }
    );
  };

  public obtenerSegunFiltro = (inputParams, callback: Function) => {
    console.log('inputParams obtenerSegunFiltro', JSON.stringify(inputParams));
    this.gqlclient.query(
      {
        query: gql`
          query ($rut: Decimal, $nombre: String, $rutEmpresa: Decimal, $paginaActual: Int, $cantidadRegistrosPorPagina: Int) {
            cliente_proveedor {
              obtenerSegunFiltro(
                filtro: { exacto: { rut: $rut, nombre: $nombre, direccion_completa: "", codigo_comuna: -1, busquedaxEstado: 1, bloqueado: false, empresa_rut: $rutEmpresa, es_cliente: true } }
                paginaActual: $paginaActual
                cantidadRegistrosPorPagina: $cantidadRegistrosPorPagina
              ) {
                mensajes {
                  codigo
                  contexto
                  texto
                  tipo
                }
                respuesta {
                  paginaActual
                  cantidadRegistrosPorPagina
                  totalPaginas
                  totalRegistros
                  registros {
                    rut
                    nombre
                    razon_social
                    codigo_direccion
                    direccion_completa
                    empresa_rut
                    fecha_registro
                    lista_precio_codigo
                    descuento_maximo
                  }
                }
              }
            }
          }
        `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { mensajes, respuesta } = response.data.cliente_proveedor.obtenerSegunFiltro;
        if (!respuesta) {
          // callback({ registros: null, paginaActual: 0, totalPaginas: 0, totalRegistros: 0 })
          callback(new QueryResult(null, 0, 0, 0));
          return;
        }

        const { registros, paginaActual, totalPaginas, totalRegistros } = respuesta;
        callback(new QueryResult(registros, paginaActual, totalPaginas, totalRegistros));
      }
    );
  };

  public obtenerSegunId(inputParams, callback: Function) {
    this.gqlclient.query(
      {
        query: gql`
          query ($entidad: cliente_proveedorInputType) {
            cliente_proveedor {
              obtenerSegunId(entidad: $entidad) {
                mensajes {
                  codigo
                  contexto
                  texto
                  tipo
                }
                respuesta {
                  rut
                  nombre
                  codigo_direccion
                  direccion_completa
                  empresa_rut
                  fecha_registro
                  lista_precio_codigo
                  descuento_maximo
                }
              }
            }
          }
        `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { mensajes, respuesta } = response.data.cliente_proveedor.obtenerSegunId;
        callback({ mensajes, respuesta });
      }
    );
  };

  public obtenerProveedores = (
    inputParams: {
      filtro: {
        exacto: { empresa_rut: number };
      };
    },
    callback: Function
  ) => {
    this.gqlclient.query(
      {
        query: gql`
          query ($filtro: FiltroInputTypeOfcliente_proveedorTOcliente_proveedorInputType) {
            cliente_proveedor {
              obtenerProveedores(paginaActual: 1, filtro: $filtro) {
                mensajes {
                  codigo
                  texto
                  tipo
                }
                respuesta {
                  paginaActual
                  cantidadRegistrosPorPagina
                  totalPaginas
                  totalRegistros
                  registros {
                    rut
                    nombre
                  }
                }
              }
            }
          }
        `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { mensajes, respuesta } = response.data.cliente_proveedor.obtenerProveedores;
        callback({ mensajes, respuesta });
      }
    );
  };

  public obtenerProveedoresMaquinas = (
    inputParams: {
      filtro: {
        exacto: { empresa_rut: number };
      };
    },
    callback: Function
  ) => {
    this.gqlclient.query(
      {
        query: gql`
          query ($filtro: FiltroInputTypeOfcliente_proveedorTOcliente_proveedorInputType) {
            cliente_proveedor {
              obtenerProveedoresMaquinas(paginaActual: 1, filtro: $filtro) {
                mensajes {
                  codigo
                  texto
                  tipo
                }
                respuesta {
                  paginaActual
                  cantidadRegistrosPorPagina
                  totalPaginas
                  totalRegistros
                  registros {
                    rut
                    nombre
                  }
                }
              }
            }
          }
        `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { mensajes, respuesta } = response.data.cliente_proveedor.obtenerProveedoresMaquinas;
        callback({ mensajes, respuesta });
      }
    );
  };

  public obtenerProveedoresSegunFiltro = (
    inputParams: {
      filtro: {
        exacto: { empresa_rut: number; rut: number; nombre: string };
      };
      cantidadRegistrosPorPagina: number;
      paginaActual: number;
    },
    callback: Function
  ) => {
    this.gqlclient.query(
      {
        query: gql`
          query ($filtro: FiltroInputTypeOfcliente_proveedorTOcliente_proveedorInputType, $paginaActual: Int, $cantidadRegistrosPorPagina: Int) {
            cliente_proveedor {
              obtenerProveedores(filtro: $filtro, paginaActual: $paginaActual, cantidadRegistrosPorPagina: $cantidadRegistrosPorPagina) {
                mensajes {
                  codigo
                  texto
                  tipo
                }
                respuesta {
                  paginaActual
                  cantidadRegistrosPorPagina
                  totalPaginas
                  totalRegistros
                  registros {
                    rut
                    nombre
                  }
                }
              }
            }
          }
        `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { mensajes, respuesta } = response.data.cliente_proveedor.obtenerProveedores;
        callback({ mensajes, respuesta });
      }
    );
  };

  ObtenerProveedorEspecifico(inputParams, callback: Function) {
    this.gqlclient.query(
      {
        query: gql`
          query ($entidad: proveedorDTOInputType) {
            cliente_proveedor {
              obtenerProveedor(entidad: $entidad) {
                mensajes {
                  codigo
                  texto
                  tipo
                }
                respuesta {
                  cliente_proveedor {
                    empresa_rut
                    rut
                    nombre
                    mail_contacto
                    telefono_principal
                    activo
                    observaciones
                    giro
                    es_canje
                    no_aplica_fec_venc
                  }
                  direccion {
                    empresa_rut
                    codigo
                    direccion_completa
                    comuna_codigo
                    provincia_codigo
                    region_codigo
                    nombre_contacto
                    condicion_pago_codigo
                  }
                }
              }
            }
          }
        `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { mensajes, respuesta } = response.data.cliente_proveedor.obtenerProveedor;
        callback({ mensajes, respuesta });
      }
    );
  }

  ObtenerClienteEspecifico(inputParams, callback: Function) {
    this.gqlclient.query(
      {
        query: gql`
          query ($entidad: proveedorDTOInputType) {
            cliente_proveedor {
              obtenerCliente(entidad: $entidad) {
                mensajes {
                  codigo
                  texto
                  tipo
                }
                respuesta {
                  cliente_proveedor {
                    empresa_rut
                    rut
                    nombre
                    mail_contacto
                    telefono_principal
                    activo
                    observaciones
                    giro
                    es_canje
                    no_aplica_fec_venc
                  }
                  direccion {
                    empresa_rut
                    codigo
                    direccion_completa
                    comuna_codigo
                    provincia_codigo
                    region_codigo
                    nombre_contacto
                    condicion_pago_codigo
                  }
                }
              }
            }
          }
        `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { mensajes, respuesta } = response.data.cliente_proveedor.obtenerCliente;
        callback({ mensajes, respuesta });
      }
    );
  }

  obtenerReporteVentaGeneral(
    inputParams: {
      entidad: {
        empresa_rut: number;
        sucursal_codigo: number;
        mes: number;
        anno: number;
        listaRubro: any[];
        listaCliente: any[];
        incl_cliente_inactivos: boolean;
      };
      paginaActual: number;
      cantidadRegistrosPorPagina: number;
    },
    callback: Function
  ) {
    this.gqlclient.query(
      {
        query: gql`
          query ($entidad: cliente_proveedorInputType, $paginaActual: Int, $cantidadRegistrosPorPagina: Int) {
            cliente_proveedor {
              obtenerReporteVentaGeneral(entidad: $entidad, paginaActual: $paginaActual, cantidadRegistrosPorPagina: $cantidadRegistrosPorPagina) {
                mensajes {
                  codigo
                  contexto
                  texto
                  tipo
                }
                respuesta {
                  paginaActual
                  cantidadRegistrosPorPagina
                  totalPaginas
                  totalRegistros
                  registros {
                    empresa_rut
                    sucursal_codigo
                    rut
                    nombre
                    razon_social
                    telefono
                    direccion_completa
                    nombrecomuna
                    nombreprovincia
                    bloqueado
                    fecha_bloqueo
                    activo
                    direccion_activa
                    codigo_vendedor
                    nombreVendedorCobrador
                    ruta_codigo
                    ruta_nombre
                    nombreTerritorio
                    fecha_ultima_venta
                    fecha_registro
                    total_maquina
                    secuencia
                    mes1
                    mes2
                    mes3
                    mes4
                    mes5
                    mes6
                    mes7
                    mes8
                    mes9
                    mes10
                    mes11
                    mes12
                    total_6meses
                    total_12meses
                    cantidad
                    sucursal_legacy
                    list_mixtura
                  }
                }
              }
            }
          }
        `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { mensajes, respuesta } = response.data.cliente_proveedor.obtenerReporteVentaGeneral;
        callback({ mensajes, respuesta });
      }
    );
  }

  obtenerReporteVentaGeneralExcel(
    inputParams: {
      entidad: {
        empresa_rut: number;
        sucursal_codigo: number;
        mes: number;
        anno: number;
        listaRubro: any[];
        retornaExcel: true;
      };
      paginaActual: number;
      cantidadRegistrosPorPagina: number;
    },
    callback: Function
  ) {
    this.gqlclient.query(
      {
        query: gql`
          query ($entidad: cliente_proveedorInputType, $paginaActual: Int, $cantidadRegistrosPorPagina: Int) {
            cliente_proveedor {
              obtenerReporteVentaGeneral(entidad: $entidad, paginaActual: $paginaActual, cantidadRegistrosPorPagina: $cantidadRegistrosPorPagina) {
                mensajes {
                  codigo
                  contexto
                  texto
                  tipo
                }
                respuesta {
                  paginaActual
                  cantidadRegistrosPorPagina
                  totalPaginas
                  totalRegistros
                  registros {
                    rutaArchivo
                  }
                }
              }
            }
          }
        `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { mensajes, respuesta } = response.data.cliente_proveedor.obtenerReporteVentaGeneral;
        callback({ mensajes, respuesta });
      }
    );
  }

  obtenerReporteVentaClienteGeneralResumen(
    inputParams: {
      entidad: {
        empresa_rut: number;
        sucursal_codigo: number;
        fecha_desde: Date;
        fecha_hasta: Date;
        listaRubro: any[];
        listaFamilia: any[];
        listaTipoCliente: any[];
        listaCanal: number[];
        retornaExcel: boolean;
      };
      paginaActual: number;
      cantidadRegistrosPorPagina: number;
    },
    callback: Function
  ) {
    this.gqlclient.query(
      {
        query: gql`
          query ($entidad: cliente_proveedorInputType, $paginaActual: Int, $cantidadRegistrosPorPagina: Int) {
            cliente_proveedor {
              obtenerReporteVentaClienteGeneralResumen(entidad: $entidad, paginaActual: $paginaActual, cantidadRegistrosPorPagina: $cantidadRegistrosPorPagina) {
                mensajes {
                  codigo
                  contexto
                  texto
                  tipo
                }
                respuesta {
                  paginaActual
                  cantidadRegistrosPorPagina
                  totalPaginas
                  totalRegistros
                  registros {
                    empresa_rut
                    sucursal_codigo
                    canal_descripcion
                    rubro_nombre
                    familia_nombre
                    monto_neto
                    descuento
                    neto_total
                  }
                }
              }
            }
          }
        `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { mensajes, respuesta } = response.data.cliente_proveedor.obtenerReporteVentaClienteGeneralResumen;
        callback({ mensajes, respuesta });
      }
    );
  }

  obtenerReporteVentaClienteGeneralResumenExcel(
    inputParams: {
      entidad: {
        empresa_rut: number;
        sucursal_codigo: number;
        fecha_desde: Date;
        fecha_hasta: Date;
        listaRubro: [];
        listaFamilia: [];
        listaTipoCliente: [];
        retornaExcel: true;
      };
      paginaActual: number;
      cantidadRegistrosPorPagina: number;
    },
    callback: Function
  ) {
    this.gqlclient.query(
      {
        query: gql`
          query ($entidad: cliente_proveedorInputType, $paginaActual: Int, $cantidadRegistrosPorPagina: Int) {
            cliente_proveedor {
              obtenerReporteVentaClienteGeneralResumen(entidad: $entidad, paginaActual: $paginaActual, cantidadRegistrosPorPagina: $cantidadRegistrosPorPagina) {
                mensajes {
                  codigo
                  contexto
                  texto
                  tipo
                }
                respuesta {
                  paginaActual
                  cantidadRegistrosPorPagina
                  totalPaginas
                  totalRegistros
                  registros {
                    rutaArchivo
                  }
                }
              }
            }
          }
        `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { mensajes, respuesta } = response.data.cliente_proveedor.obtenerReporteVentaClienteGeneralResumen;
        callback({ mensajes, respuesta });
      }
    );
  }

  obtenerReporteVentaClienteGeneralDetalle(
    inputParams: {
      entidad: {
        empresa_rut: number;
        sucursal_codigo: number;
        fecha_desde: Date;
        fecha_hasta: Date;
        listaRubro: any[];
        listaFamilia: any[];
        listaTipoCliente: any[];
        vendedorSel: any[];
      };
      paginaActual: number;
      cantidadRegistrosPorPagina: number;
    },
    callback: Function
  ) {
    this.gqlclient.query(
      {
        query: gql`
          query ($entidad: cliente_proveedorInputType, $paginaActual: Int, $cantidadRegistrosPorPagina: Int) {
            cliente_proveedor {
              obtenerReporteVentaClienteGeneralDetalle(entidad: $entidad, paginaActual: $paginaActual, cantidadRegistrosPorPagina: $cantidadRegistrosPorPagina) {
                mensajes {
                  codigo
                  contexto
                  texto
                  tipo
                }
                respuesta {
                  paginaActual
                  cantidadRegistrosPorPagina
                  totalPaginas
                  totalRegistros
                  registros {
                    empresa_rut
                    sucursal_codigo
                    tipo_cliente_nombre
                    rut
                    razon_social
                    direccion_completa
                    nombrecomuna
                    nombreprovincia
                    rubro_nombre
                    familia_nombre
                    monto_neto
                    descuento
                    neto_total
                    tipo_cliente_nombre
                    canal_descripcion
                  }
                }
              }
            }
          }
        `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { mensajes, respuesta } = response.data.cliente_proveedor.obtenerReporteVentaClienteGeneralDetalle;
        callback({ mensajes, respuesta });
      }
    );
  }

  obtenerReporteVentaClienteGeneralDetalleExcel(
    inputParams: {
      entidad: {
        empresa_rut: number;
        sucursal_codigo: number;
        fecha_desde: Date;
        fecha_hasta: Date;
        listaRubro: [];
        listaFamilia: [];
        listaTipoCliente: [];
        retornaExcel: true;
      };
      paginaActual: number;
      cantidadRegistrosPorPagina: number;
    },
    callback: Function
  ) {
    this.gqlclient.query(
      {
        query: gql`
          query ($entidad: cliente_proveedorInputType, $paginaActual: Int, $cantidadRegistrosPorPagina: Int) {
            cliente_proveedor {
              obtenerReporteVentaClienteGeneralDetalle(entidad: $entidad, paginaActual: $paginaActual, cantidadRegistrosPorPagina: $cantidadRegistrosPorPagina) {
                mensajes {
                  codigo
                  contexto
                  texto
                  tipo
                }
                respuesta {
                  paginaActual
                  cantidadRegistrosPorPagina
                  totalPaginas
                  totalRegistros
                  registros {
                    rutaArchivo
                  }
                }
              }
            }
          }
        `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { mensajes, respuesta } = response.data.cliente_proveedor.obtenerReporteVentaClienteGeneralDetalle;
        callback({ mensajes, respuesta });
      }
    );
  }

  obtenerReporteVentaClienteEspecifico(
    inputParams: {
      entidad: {
        empresa_rut: number;
        sucursal_codigo: number;
        fecha_desde: Date;
        fecha_hasta: Date;
        listaTipoCliente: any[];
        listaCliente: any[];
      };
      paginaActual: number;
      cantidadRegistrosPorPagina: number;
    },
    callback: Function
  ) {
    this.gqlclient.query(
      {
        query: gql`
          query ($entidad: cliente_proveedorInputType, $paginaActual: Int, $cantidadRegistrosPorPagina: Int) {
            cliente_proveedor {
              obtenerReporteVentaClienteEspecifico(entidad: $entidad, paginaActual: $paginaActual, cantidadRegistrosPorPagina: $cantidadRegistrosPorPagina) {
                mensajes {
                  codigo
                  contexto
                  texto
                  tipo
                }
                respuesta {
                  paginaActual
                  cantidadRegistrosPorPagina
                  totalPaginas
                  totalRegistros
                  registros {
                    empresa_rut
                    sucursal_codigo
                    tipo_cliente_nombre
                    rut
                    razon_social
                    direccion_completa
                    nombrecomuna
                    nombreprovincia
                    rubro_nombre
                    familia_nombre
                    tipo_dte_codigo
                    tipo_dte_nombre
                    folio
                    fecha_registro
                    monto_neto
                    descuento
                    neto_total
                  }
                }
              }
            }
          }
        `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { mensajes, respuesta } = response.data.cliente_proveedor.obtenerReporteVentaClienteEspecifico;
        callback({ mensajes, respuesta });
      }
    );
  }

  obtenerReporteVentaClienteEspecificoExcel(
    inputParams: {
      entidad: {
        empresa_rut: number;
        sucursal_codigo: number;
        fecha_desde: Date;
        fecha_hasta: Date;
        listaTipoCliente: any[];
        listaCliente: any[];
        retornaExcel: true;
      };
      paginaActual: number;
      cantidadRegistrosPorPagina: number;
    },
    callback: Function
  ) {
    this.gqlclient.query(
      {
        query: gql`
          query ($entidad: cliente_proveedorInputType, $paginaActual: Int, $cantidadRegistrosPorPagina: Int) {
            cliente_proveedor {
              obtenerReporteVentaClienteEspecifico(entidad: $entidad, paginaActual: $paginaActual, cantidadRegistrosPorPagina: $cantidadRegistrosPorPagina) {
                mensajes {
                  codigo
                  contexto
                  texto
                  tipo
                }
                respuesta {
                  paginaActual
                  cantidadRegistrosPorPagina
                  totalPaginas
                  totalRegistros
                  registros {
                    rutaArchivo
                  }
                }
              }
            }
          }
        `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { mensajes, respuesta } = response.data.cliente_proveedor.obtenerReporteVentaClienteEspecifico;
        callback({ mensajes, respuesta });
      }
    );
  }

  obtenerReporteVentaClienteDetalleProducto(
    inputParams: {
      entidad: {
        empresa_rut: number;
        sucursal_codigo: number;
        fecha_desde: Date;
        fecha_hasta: Date;
        listaTipoCliente: any[];
        listaCliente: any[];
        producto_descuento: boolean;
      };
      paginaActual: number;
      cantidadRegistrosPorPagina: number;
    },
    callback: Function
  ) {
    this.gqlclient.query(
      {
        query: gql`
          query ($entidad: cliente_proveedorInputType, $paginaActual: Int, $cantidadRegistrosPorPagina: Int) {
            cliente_proveedor {
              obtenerReporteVentaClienteDetalleProducto(entidad: $entidad, paginaActual: $paginaActual, cantidadRegistrosPorPagina: $cantidadRegistrosPorPagina) {
                mensajes {
                  codigo
                  contexto
                  texto
                  tipo
                }
                respuesta {
                  paginaActual
                  cantidadRegistrosPorPagina
                  totalPaginas
                  totalRegistros
                  registros {
                    empresa_rut
                    sucursal_codigo
                    tipo_cliente_nombre
                    rut
                    razon_social
                    direccion_completa
                    nombrecomuna
                    nombreprovincia
                    producto_codigo
                    sku
                    producto_nombre
                    formato_codigo
                    formato_nombre
                    rubro_nombre
                    familia_nombre
                    cantidad
                    monto_neto
                    descuento
                    neto_total
                  }
                }
              }
            }
          }
        `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { mensajes, respuesta } = response.data.cliente_proveedor.obtenerReporteVentaClienteDetalleProducto;
        callback({ mensajes, respuesta });
      }
    );
  }

  obtenerReporteVentaClienteDetalleProductoExcel(
    inputParams: {
      entidad: {
        empresa_rut: number;
        sucursal_codigo: number;
        fecha_desde: Date;
        fecha_hasta: Date;
        listaTipoCliente: any[];
        listaCliente: any[];
        producto_descuento: boolean;
        retornaExcel: true;
      };
      paginaActual: number;
      cantidadRegistrosPorPagina: number;
    },
    callback: Function
  ) {
    this.gqlclient.query(
      {
        query: gql`
          query ($entidad: cliente_proveedorInputType, $paginaActual: Int, $cantidadRegistrosPorPagina: Int) {
            cliente_proveedor {
              obtenerReporteVentaClienteDetalleProducto(entidad: $entidad, paginaActual: $paginaActual, cantidadRegistrosPorPagina: $cantidadRegistrosPorPagina) {
                mensajes {
                  codigo
                  contexto
                  texto
                  tipo
                }
                respuesta {
                  paginaActual
                  cantidadRegistrosPorPagina
                  totalPaginas
                  totalRegistros
                  registros {
                    rutaArchivo
                  }
                }
              }
            }
          }
        `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { mensajes, respuesta } = response.data.cliente_proveedor.obtenerReporteVentaClienteDetalleProducto;
        callback({ mensajes, respuesta });
      }
    );
  }

  agregarProveedor(
    inputParams: {
      entidad: {
        cliente_proveedor: {
          empresa_rut: number;
          rut_usuario_creacion: number;
          rut: number;
          nombre: string;
          giro: string;
          telefono_principal: string;
          mail_contacto: string;
          activo: boolean;
          observaciones: string;
          no_aplica_fec_venc: boolean;
          es_canje: boolean;
          tiene_maquina: boolean;
        };
        direccion: {
          direccion_completa: string;
          comuna_codigo: number;
          nombre_contacto: string;
          condicion_pago_codigo: number;
        };
      };
    },
    callback: Function
  ) {
    this.gqlclient.mutate(
      {
        mutation: gql`
          mutation ($entidad: proveedorDTOInputType) {
            cliente_proveedor {
              agregarProveedor(entidad: $entidad) {
                mensajes {
                  codigo
                  texto
                  tipo
                }
                respuesta {
                  cliente_proveedor {
                    empresa_rut
                    rut
                    nombre
                    mail_contacto
                    telefono_principal
                    activo
                    observaciones
                    giro
                    es_canje
                    no_aplica_fec_venc
                    tiene_maquina
                  }
                  direccion {
                    empresa_rut
                    codigo
                    direccion_completa
                    comuna_codigo
                    nombre_contacto
                    condicion_pago_codigo
                  }
                }
              }
            }
          }
        `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { mensajes, respuesta } = response.data.cliente_proveedor.agregarProveedor;
        callback({ mensajes, respuesta });
      }
    );
  }

  editarProveedor(
    inputParams: {
      entidad: {
        cliente_proveedor: {
          empresa_rut: number;
          rut_usuario_actualiza: number;
          rut: number;
          nombre: string;
          giro: string;
          telefono_principal: string;
          mail_contacto: string;
          activo: boolean;
          observaciones: string;
          no_aplica_fec_venc: boolean;
          es_canje: boolean;
          tiene_maquina: boolean;
        };
        direccion: {
          codigo: number;
          direccion_completa: string;
          comuna_codigo: number;
          nombre_contacto: string;
          condicion_pago_codigo: number;
        };
      };
    },
    callback: Function
  ) {
    this.gqlclient.mutate(
      {
        mutation: gql`
          mutation ($entidad: proveedorDTOInputType) {
            cliente_proveedor {
              editarProveedor(entidad: $entidad) {
                mensajes {
                  codigo
                  texto
                  tipo
                }
                respuesta {
                  cliente_proveedor {
                    empresa_rut
                    rut
                    nombre
                    mail_contacto
                    telefono_principal
                    activo
                    observaciones
                    giro
                    es_canje
                    no_aplica_fec_venc
                    tiene_maquina
                  }
                  direccion {
                    empresa_rut
                    codigo
                    direccion_completa
                    comuna_codigo
                    nombre_contacto
                    condicion_pago_codigo
                  }
                }
              }
            }
          }
        `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { mensajes, respuesta } = response.data.cliente_proveedor.editarProveedor;
        callback({ mensajes, respuesta });
      }
    );
  }

  obtenerProveedoresDTO(
    inputParams: {
      entidad: {
        cliente_proveedor: {
          empresa_rut: number;
        };
      };
      paginaActual: number;
      cantidadRegistrosPorPagina: number;
    },
    callback: Function
  ) {
    this.gqlclient.query(
      {
        query: gql`
          query ($entidad: proveedorDTOInputType, $paginaActual: Int, $cantidadRegistrosPorPagina: Int) {
            cliente_proveedor {
              obtenerProveedoresDTO(entidad: $entidad, paginaActual: $paginaActual, cantidadRegistrosPorPagina: $cantidadRegistrosPorPagina) {
                mensajes {
                  codigo
                  texto
                  tipo
                }
                respuesta {
                  paginaActual
                  cantidadRegistrosPorPagina
                  totalPaginas
                  totalRegistros
                  registros {
                    cliente_proveedor {
                      empresa_rut
                      rut
                      nombre
                      mail_contacto
                      telefono_principal
                      activo
                      observaciones
                      giro
                      es_canje
                      no_aplica_fec_venc
                      tiene_maquina
                    }
                    direccion {
                      empresa_rut
                      codigo
                      direccion_completa
                      comuna_codigo
                      provincia_codigo
                      region_codigo
                      nombre_contacto
                      condicion_pago_codigo
                      fono_movil
                    }
                  }
                }
              }
            }
          }
        `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { mensajes, respuesta } = response.data.cliente_proveedor.obtenerProveedoresDTO;
        callback({ mensajes, respuesta });
      }
    );
  }

  ObteneProveedorEsCliente(
    inputParams,
    callback: Function
  ) {
    this.gqlclient.query(
      {
        query: gql`
          query ($entidad: cliente_proveedorInputType) {
            cliente_proveedor {
              obteneProveedorEsCliente(entidad: $entidad) {
                mensajes {
                  codigo
                  texto
                  tipo
                }
                  respuesta {
                    rut
                    razon_social
                    codigo_direccion
                    codigo_comuna
                    provincia_codigo
                    region_codigo
                    direccion_completa
                    giro
                    telefono_principal
                    telefono_secundario
                    mail_contacto
                    observaciones
                    condicion_pago_codigo
                    no_aplica_fec_venc
                    activo
                    tiene_maquina
                    es_canje
                  }
                }
              }
            }

        `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { mensajes, respuesta } = response.data.cliente_proveedor.obteneProveedorEsCliente;
        callback({ mensajes, respuesta });
      }
    );
  }

  obtenerClientesAsignacionTraspaso(inputParams, callback: Function) {
    this.gqlclient.query(
      {
        query: gql`
          mutation ($entidad: cliente_proveedorInputType, $clientes: [cliente_proveedorInputType]) {
            cliente_proveedor {
              agregarClienteAsignadoTraspaso(entidad: $entidad, clientes: $clientes) {
                mensajes {
                  codigo
                  texto
                  tipo
                }
                respuesta {
                  empresa_rut
                  sucursal_codigo
                  codigo_vendedor
                  rut
                  codigo_direccion
                }
              }
            }
          }
        `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { mensajes, respuesta } = response.data.cliente_proveedor.agregarClienteAsignadoTraspaso;
        callback({ mensajes, respuesta });
      }
    );
  }

  generarIPTVendedorManual(inputParams, callback: Function) {
    this.gqlclient.query(
      {
        query: gql`
          mutation ($entidad: ipt_vendedor_clienteInputType, $clientes: [ipt_vendedor_clienteInputType]) {
            ipt_vendedor_cliente {
              generarIptManual(entidad: $entidad, clientes: $clientes) {
                mensajes {
                  codigo
                  texto
                  tipo
                }
                respuesta {
                  empresa_rut
                  vendedor_codigo
                  cliente_proveedor_rut
                  direccion_codigo
                  lunes
                  martes
                  miercoles
                  jueves
                  viernes
                  sabado
                  domingo
                }
              }
            }
          }
        `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { mensajes, respuesta } = response.data.ipt_vendedor_cliente.generarIptManual;
        callback({ mensajes, respuesta });
      }
    );
  }

  generarIPTVendedorAuto(inputParams, callback: Function) {
    this.gqlclient.query(
      {
        query: gql`
          mutation ($entidad: ipt_vendedor_clienteInputType, $clientes: [ipt_vendedor_clienteInputType]) {
            ipt_vendedor_cliente {
              generarIptAutomatico(entidad: $entidad, clientes: $clientes) {
                mensajes {
                  codigo
                  texto
                  tipo
                }
                respuesta {
                  empresa_rut
                  vendedor_codigo
                  lunes
                  martes
                  miercoles
                  jueves
                  viernes
                  sabado
                  domingo
                }
              }
            }
          }
        `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { mensajes, respuesta } = response.data.ipt_vendedor_cliente.generarIptAutomatico;
        callback({ mensajes, respuesta });
      }
    );
  }

  public obtenerSegunFiltroAsignar = (inputParams, callback: Function) => {
    console.log('inputParams obtenerSegunFiltroAsignar', JSON.stringify(inputParams));
    this.gqlclient.query(
      {
        query: gql`
          query ($entidad: cliente_proveedorInputType, $paginaActual: Int, $cantidadRegistrosPorPagina: Int) {
            cliente_proveedor {
              obtenerClienteParaAsignar(entidad: $entidad, paginaActual: $paginaActual, cantidadRegistrosPorPagina: $cantidadRegistrosPorPagina) {
                mensajes {
                  codigo
                  texto
                  tipo
                }
                respuesta {
                  paginaActual
                  cantidadRegistrosPorPagina
                  totalPaginas
                  totalRegistros
                  registros {
                    empresa_rut
                    codigo_vendedor
                    rut
                    razon_social
                    activo
                    codigo_direccion
                    direccion_completa
                    nombrecomuna
                    nombreprovincia
                    ruta_nombre
                    nombreTerritorio
                    lunes
                    martes
                    miercoles
                    jueves
                    viernes
                    sabado
                    domingo
                    tipo_cliente_nombre
                  }
                }
              }
            }
          }
        `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { mensajes, respuesta } = response.data.cliente_proveedor.obtenerClienteParaAsignar;
        if (!respuesta) {
          // callback({ registros: null, paginaActual: 0, totalPaginas: 0, totalRegistros: 0 })
          callback(new QueryResult(null, 0, 0, 0));
          return;
        }

        const { registros, paginaActual, totalPaginas, totalRegistros } = respuesta;
        callback(new QueryResult(registros, paginaActual, totalPaginas, totalRegistros));
      }
    );
  };

  obtenerClienteTraspaso(inputParams, callback: Function) {
    this.gqlclient.query(
      {
        query: gql`
          query ($entidad: cliente_proveedorInputType, $paginaActual: Int, $cantidadRegistrosPorPagina: Int) {
            cliente_proveedor {
              obtenerClienteTraspaso(entidad: $entidad, paginaActual: $paginaActual, cantidadRegistrosPorPagina: $cantidadRegistrosPorPagina) {
                mensajes {
                  codigo
                  texto
                  tipo
                }
                respuesta {
                  paginaActual
                  cantidadRegistrosPorPagina
                  totalPaginas
                  totalRegistros
                  registros {
                    empresa_rut
                    codigo_vendedor
                    rut
                    razon_social
                    activo
                    codigo_direccion
                    direccion_completa
                    nombrecomuna
                    nombreprovincia
                    ruta_codigo
                    ruta_nombre
                    territorio_codigo
                    nombreTerritorio
                    lunes
                    martes
                    miercoles
                    jueves
                    viernes
                    sabado
                    domingo
                    tipo_cliente_codigo
                    tipo_cliente_nombre
                    seleccion
                  }
                }
              }
            }
          }
        `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { mensajes, respuesta } = response.data.cliente_proveedor.obtenerClienteTraspaso;
        callback({ mensajes, respuesta });
      }
    );
  }

  existe(
    inputParams: {
      rutCliente: number;
      rutEmpresa: number;
    },
    callback: Function
  ) {
    this.gqlclient.query(
      {
        query: gql`
          query ($rutCliente: Decimal, $rutEmpresa: Decimal) {
            cliente_proveedor {
              existe(entidad: { rut: $rutCliente, empresa_rut: $rutEmpresa }) {
                mensajes {
                  codigo
                  contexto
                  texto
                  tipo
                }
                respuesta
              }
            }
          }
        `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { mensajes, respuesta } = response.data.cliente_proveedor.existe;
        callback({ mensajes, respuesta });
      }
    );
  }

  esProveedor(
    inputParams: {
      rutCliente: number;
      rutEmpresa: number;
    },
    callback: Function
  ) {
    this.gqlclient.query(
      {
        query: gql`
          query ($rutEmpresa: Decimal, $rutCliente: Decimal) {
            cliente_proveedor {
              esClienteProveedor(rutEmpresa: $rutEmpresa, rutCliente: $rutCliente) {
                mensajes {
                  codigo
                  contexto
                  texto
                  tipo
                }
                respuesta
              }
            }
          }
        `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { mensajes, respuesta } = response.data.cliente_proveedor.esClienteProveedor;
        callback({ mensajes, respuesta });
      }
    );
  }

  estadoCliente(
    inputParams: {
      entidad: {
        rut: number;
        empresa_rut: number;
      };
    },
    callback: Function
  ) {
    this.gqlclient.query(
      {
        query: gql`
          query ($entidad: cliente_proveedorInputType) {
            cliente_proveedor {
              estadoCliente(entidad: $entidad) {
                mensajes {
                  codigo
                  contexto
                  texto
                  tipo
                }
                respuesta {
                  rutCliente
                  rutEmpresa
                  bloqueado
                  activo
                }
              }
            }
          }
        `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { mensajes, respuesta } = response.data.cliente_proveedor.estadoCliente;
        callback({ mensajes, respuesta });
      }
    );
  }

  estadoProveedor(
    inputParams: {
      entidad: {
        rut: number;
        empresa_rut: number;
      };
    },
    callback: Function
  ) {
    this.gqlclient.query(
      {
        query: gql`
          query ($entidad: cliente_proveedorInputType) {
            cliente_proveedor {
              estadoProveedor(entidad: $entidad) {
                mensajes {
                  codigo
                  contexto
                  texto
                  tipo
                }
                respuesta {
                  rutCliente
                  rutEmpresa
                  activo
                }
              }
            }
          }
        `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { mensajes, respuesta } = response.data.cliente_proveedor.estadoProveedor;
        callback({ mensajes, respuesta });
      }
    );
  }

  obtenerSegunFiltroSoloClientesDeuda = (
    inputParams: {
      entidad: {
        empresa_rut: number;
        es_cliente: boolean;
        nombre: string;
        rut: number;
      };
      cantidadRegistrosPorPagina: number;
      paginaActual: number;
    },
    callback: Function
  ) => {
    this.gqlclient.query(
      {
        query: gql`
          query ($entidad: cliente_proveedorInputType, $paginaActual: Int, $cantidadRegistrosPorPagina: Int) {
            cliente_proveedor {
              obtenerSegunFiltroSoloClientesDeudas(entidad: $entidad, paginaActual: $paginaActual, cantidadRegistrosPorPagina: $cantidadRegistrosPorPagina) {
                mensajes {
                  codigo
                  contexto
                  texto
                  tipo
                }
                respuesta {
                  paginaActual
                  cantidadRegistrosPorPagina
                  totalPaginas
                  totalRegistros
                  registros {
                    rut
                    nombre
                    razon_social
                    codigo_direccion
                    direccion_completa
                    empresa_rut
                    fecha_registro
                    lista_precio_codigo
                    descuento_maximo
                    giro
                    telefono_principal
                    afecto_reglas_comerciales
                    codigo_direccion
                    condicion_pago_codigo
                  }
                }
              }
            }
          }
        `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { mensajes, respuesta } = response.data.cliente_proveedor.obtenerSegunFiltroSoloClientesDeudas;
        if (!respuesta) {
          // callback({ registros: null, paginaActual: 0, totalPaginas: 0, totalRegistros: 0 })
          callback(new QueryResult(null, 0, 0, 0));
          return;
        }

        const { registros, paginaActual, totalPaginas, totalRegistros } = respuesta;
        callback(new QueryResult(registros, paginaActual, totalPaginas, totalRegistros));
      }
    );
  };
}
